export const NORM_ORGANIZATION_ID_KEY = 'normAppOrganizationId';
export const NORM_ORGANIZATION_NAME_KEY = 'normAppOrganizationName';
export const NORM_IS_INTERNAL_VIEW_KEY = 'normIsInternalView';

const hasLocalStorage = (): boolean => {
  try {
    if (typeof window === 'undefined') {
      return false;
    }

    const storage = window.localStorage;
    return (
      typeof storage !== 'undefined' &&
      typeof storage.getItem === 'function' &&
      typeof storage.setItem === 'function' &&
      typeof storage.removeItem === 'function'
    );
  } catch {
    return false;
  }
};

export const getIsInternalView = (): boolean => {
  if (!hasLocalStorage()) {
    return false;
  }

  try {
    return window.localStorage.getItem(NORM_IS_INTERNAL_VIEW_KEY) === 'true';
  } catch {
    return false;
  }
};

export function defaultHeaders(
  token: string,
  organizationId: string | null,
): HeadersInit {
  if (organizationId === null) {
    throw new Error('Organization ID must not be null');
  }

  const isInternalView = getIsInternalView();

  return {
    Authorization: `Bearer ${token}`,
    'X-Organization-ID': organizationId,
    'X-Internal-View': isInternalView.toString(),
  };
}

export const setSessionOrganization = (
  id: string,
  name: string,
  isInternalView: boolean,
): void => {
  if (!hasLocalStorage()) {
    return;
  }

  window.localStorage.setItem(NORM_ORGANIZATION_ID_KEY, id);
  window.localStorage.setItem(NORM_ORGANIZATION_NAME_KEY, name);
  window.localStorage.setItem(
    NORM_IS_INTERNAL_VIEW_KEY,
    isInternalView.toString(),
  );
};

export interface Organization {
  id: string;
  name: string;
  isInternalView: boolean;
}

export const getSessionOrganization = (): Organization | null => {
  if (!hasLocalStorage()) {
    return null;
  }

  try {
    const id = window.localStorage.getItem(NORM_ORGANIZATION_ID_KEY);
    const name = window.localStorage.getItem(NORM_ORGANIZATION_NAME_KEY);
    const isInternalView =
      window.localStorage.getItem(NORM_IS_INTERNAL_VIEW_KEY) === 'true';

    if (id && name) {
      return {
        id: id,
        name: name,
        isInternalView: isInternalView,
      };
    }

    return null;
  } catch (error) {
    console.error('Failed to read session organization:', error);
    return null;
  }
};

export const clearSessionOrganization = (): void => {
  if (!hasLocalStorage()) {
    return;
  }

  window.localStorage.removeItem(NORM_ORGANIZATION_ID_KEY);
  window.localStorage.removeItem(NORM_ORGANIZATION_NAME_KEY);
  window.localStorage.removeItem(NORM_IS_INTERNAL_VIEW_KEY);
};
